import React from 'react';
import { RightSidebar } from "../../../_partials/Layout";
import Sortable from "../../../../componets/Sortable";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { reorderTips } from "../../../../actions/mine_craft/tipsActions";

const _SidebarIndex = () => {
  const dispatch = useAppDispatch();
  const reorderIds  = useAppSelector(state => state.mineCraft.tips.ids);
  const tips        = useAppSelector(state => state.mineCraft.tips.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderTips({ ids }));
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>

      <hr className="v-divider" />

      <h6 className="v-content-label o-sm">Reorder Helps</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            items={tips}
            titleKey='title'
          />
      }
    </RightSidebar>
  )
}

export default _SidebarIndex;
